// @see https://codepen.io/tahadib/pen/vYOEdBp
//ELEMENT SELECTORS
var player = document.querySelector(".player");
var video = document.querySelector("#video");
var playBtn = document.querySelector("#control-play");
var stopBtn = document.querySelector("#control-stop");
var volumeBtn = document.querySelector("#control-volume");
var volumeSlider = document.querySelector(".volume-slider");
var volumeFill = document.querySelector(".volume-filled");
var progressSlider = document.querySelector(".progress");
var progressFill = document.querySelector(".progress-filled");
var textCurrent = document.querySelector(".time-current");
//const textTotal = document.querySelector('.time-total');
var speedBtns = document.querySelectorAll(".speed-item");
var fullscreenBtn = document.querySelector("#control-fullscreen");
//GLOBAL VARS
var lastVolume = 1;
//PLAYER FUNCTIONS
function stopPlay(ev) {
    ev.preventDefault();
    video.pause();
    video.currentTime = 0;
}
function togglePlay(ev) {
    ev.preventDefault();
    if (video.paused) video.play();
    else video.pause();
}
function togglePlayBtn() {
    if (video.paused) playBtn.textContent = "play_arrow";
    else playBtn.textContent = "pause";
}
function syncVolume(volume) {
    if (volume > 0.5) volumeBtn.textContent = "volume_up";
    else if (volume < 0.5 && volume > 0) volumeBtn.textContent = "volume_down";
    else if (volume === 0) volumeBtn.textContent = "volume_mute";
}
function toggleMute(ev) {
    ev.preventDefault();
    if (video.volume) {
        lastVolume = video.volume;
        video.volume = 0;
        volumeBtn.textContent = "volume_mute";
        volumeFill.style.width = "0";
    } else {
        video.volume = lastVolume;
        syncVolume(video.volume);
        volumeFill.style.width = "".concat(video.volume * 100, "%");
    }
}
function changeVolume(param) {
    var offsetX = param.offsetX;
    var volume = offsetX / volumeSlider.offsetWidth;
    volume < 0.1 ? volume = 0 : volume;
    volumeFill.style.width = "".concat(volume * 100, "%");
    video.volume = volume;
    syncVolume(volume);
    lastVolume = volume;
}
function neatTime(time) {
    // const hours = Math.floor((time % 86400) / 3600)
    var minutes = Math.floor(time % 3600 / 60);
    var seconds = Math.floor(time % 60);
    seconds = seconds > 9 ? seconds : "0".concat(seconds);
    return "".concat(minutes, ":").concat(seconds);
}
function updateProgress() {
    progressFill.style.width = "".concat(video.currentTime / video.duration * 100, "%");
    textCurrent.innerHTML = "".concat(neatTime(video.currentTime), " / ").concat(neatTime(video.duration));
// textTotal.innerHTML = neatTime(video.duration);
}
function setProgress(param) {
    var offsetX = param.offsetX;
    var newTime = offsetX / progressSlider.offsetWidth;
    progressFill.style.width = "".concat(newTime * 100, "%");
    video.currentTime = newTime * video.duration;
}
function launchIntoFullscreen(element) {
    if (element.requestFullscreen) element.requestFullscreen();
    else if (element.mozRequestFullScreen) element.mozRequestFullScreen();
    else if (element.webkitRequestFullscreen) element.webkitRequestFullscreen();
    else if (element.msRequestFullscreen) element.msRequestFullscreen();
}
function exitFullscreen() {
    if (document.exitFullscreen) document.exitFullscreen();
    else if (document.mozCancelFullScreen) document.mozCancelFullScreen();
    else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
}
var fullscreen = false;
function toggleFullscreen(ev) {
    ev.preventDefault();
    if (fullscreen) {
        exitFullscreen();
        fullscreenBtn.textContent = "fullscreen";
    } else {
        launchIntoFullscreen(player);
        fullscreenBtn.textContent = "fullscreen_exit";
    }
    fullscreen = !fullscreen;
}
function setSpeed() {
    video.playbackRate = this.dataset.speed;
    speedBtns.forEach(function(param) {
        var classList = param.classList;
        return classList.remove("active");
    });
    this.classList.add("active");
}
function handleKeypress(param) {
    var key = param.key;
    switch(key){
        case " ":
            togglePlay(new Event("click"));
            break;
        case "ArrowRight":
            video.currentTime += 5;
            break;
        case "ArrowLeft":
            video.currentTime -= 5;
            break;
    }
}
//EVENT LISTENERS
playBtn.addEventListener("click", togglePlay);
stopBtn.addEventListener("click", stopPlay);
video.addEventListener("click", togglePlay);
video.addEventListener("play", togglePlayBtn);
video.addEventListener("pause", togglePlayBtn);
video.addEventListener("ended", togglePlayBtn);
video.addEventListener("timeupdate", updateProgress);
volumeBtn.addEventListener("click", toggleMute);
volumeSlider.addEventListener("click", changeVolume);
progressSlider.addEventListener("click", setProgress);
fullscreenBtn.addEventListener("click", toggleFullscreen);
speedBtns.forEach(function(speedBtn) {
    speedBtn.addEventListener("click", setSpeed);
});
window.addEventListener("keydown", handleKeypress);
// @see https://codepen.io/eastcoastdeveloper/pen/LmxqKa
var mp4 = document.getElementById("mp4");
var webm = document.getElementById("webm");
var selected = document.getElementById("selected");
var mp4Url = "";
var webmUrl = "";
function playVideo(ID) {
    switch(ID){
        case 1:
            mp4Url = "https://fredrickjaxx.is/_assets/video/blossoms.mp4";
            webmUrl = "https://fredrickjaxx.is/_assets/video/blossoms.Webm";
            break;
        case 2:
            mp4Url = "https://fredrickjaxx.is/_assets/video/splash.mp4";
            webmUrl = "https://fredrickjaxx.is/_assets/video/splash.Webm";
            break;
        case 3:
            mp4Url = "https://fredrickjaxx.is/_assets/video/transport.mp4";
            webmUrl = "https://fredrickjaxx.is/_assets/video/transport.Webm";
            break;
        case 4:
            mp4Url = "https://fredrickjaxx.is/_assets/video/walking.mp4";
            webmUrl = "https://fredrickjaxx.is/_assets/video/walking.Webm";
            break;
    }
    mp4.setAttribute("src", mp4Url);
    webm.setAttribute("src", webmUrl);
    selected.setAttribute("value", ID);
    video.load();
    video.play();
}
// Previous & Next
document.getElementById("control-previous").addEventListener("click", function(ev) {
    ev.preventDefault();
    var id = parseInt(selected.getAttribute("value"));
    playVideo(id === 1 ? 4 : id - 1);
});
document.getElementById("control-next").addEventListener("click", function(ev) {
    ev.preventDefault();
    var id = parseInt(selected.getAttribute("value"));
    playVideo(id === 4 ? 1 : id + 1);
});

//# sourceMappingURL=play.8e328f84.js.map
